const APPLICATION_LIST = [
    {
        value: "abbvie_pro",
        text: "AbbVie Pro",
    },
    {
        value: "abbvie_pro_medical",
        text: "AbbVie Pro Medical",
    },
    {
        value: "allergan_pro_ami",
        text: "AbbVie Pro AMI",
    },
    {
        value: "allergan_pro",
        text: "Allergan Pro",
    },
    {
        value: "abbvie_pro_training",
        text: "Abbvie Pro Training",
    },
];

export const BASIC_LOGIN_APP_LIST = [
    {
        applicationId: "abbvie_pro",
        applicationName: "Abbvie Pro",
    },
    {
        applicationId: "abbvie_pro_medical",
        applicationName: "Abbvie Pro Medical",
    },
    {
        applicationId: "abbvie_pro_training",
        applicationName: "Abbvie Pro Training",
    },

    {
        applicationId: "allergan_pro_ami",
        applicationName: "Abbvie Pro AMI",
    },
    {
        applicationId: "abbvie_lmbc",
        applicationName: "Abbvie LMBC",
    },

    {
        applicationId: "abbvie_lets_talk_eczema_ous",
        applicationName: "Abbvie Lets Talk Eczema",
    },
    {
        applicationId: "abbvie_talkoverra_ous",
        applicationName: "Abbvie Talkoverra",
    },
    {
        applicationId: "abbvie_skyrizi",
        applicationName: "Abbvie Skyrizi",
    },
    {
        applicationId: "abbvie_skyrizi_me",
        applicationName: "Abbvie Skyrizi ME",
    },
    {
        applicationId: "abbvie_rinvoq",
        applicationName: "Abbvie Rinvoq",
    },
    {
        applicationId: "abbvie_rinvoq_me",
        applicationName: "Abbvie Rinvoq ME",
    },
    {
        applicationId: "abbvie_infocenter",
        applicationName: "Abbvie Infocenter",
    },
    {
        applicationId: "allergan_pro",
        applicationName: "Allergan Pro",
    },
    {
        applicationId: "infocenter_rheuma",
        applicationName: "Infocenter Rheuma",
    },
    {
        applicationId: "infocenter_gastro",
        applicationName: "Infocenter Gastro",
    },
    {
        applicationId: "skyrizi_de",
        applicationName: "Skyrizi DE",
    },

    {
        applicationId: "tale_of_two_patients",
        applicationName: "Tale of Two Patients",
    },
    {
        applicationId: "optive",
        applicationName: "Optive",
    },
    {
        applicationId: "xen_implantat",
        applicationName: "Xen Implantat",
    },
    {
        applicationId: "abbvie_care_ous",
        applicationName: "Abbvie Care",
    },
    {
        applicationId: "arzneimittelsuche",
        applicationName: "Arzneimittelsuche",
    },
    {
        applicationId: "skyrizi",
        applicationName: "Skyrizi",
    },
    {
        applicationId: "meinparkinson",
        applicationName: "Meinparkinson",
    },
    {
        applicationId: "healthcareheroes",
        applicationName: "Healthcareheroes",
    },
    {
        applicationId: "abbvie_pro_acuiti",
        applicationName: "Abbvie Pro ACUITI",
    },
    {
        applicationId: "yasamlardaizbirak",
        applicationName: "Yasamlardaizbirak",
    },
    {
        applicationId: "support_center",
        applicationName: "Support Center",
    },
    {
        applicationId: "demo",
        applicationName: "Sitegenarator",
    },
    {
        applicationId: "dry-eye",
        applicationName: "Dry Eye",
    },
    {
        applicationId: "acne-inversa",
        applicationName: "Acne Inversa",
    },
    {
        applicationId: "sagliginicinkesfet",
        applicationName: "Sagliginicinkesfet",
    },
];

export default APPLICATION_LIST;
